import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'

export default class DeleteException extends BaseErrorHandler {
    protected Code: string = 'Common.DeleteException';
    protected AlertType:AlertTypeEnum=AlertTypeEnum.WARNING;

    customizeAction(): void {
    }
}
